import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext.js';
import companySettlementService from '../../../services/companySettlementService.js';
import { getCurrentMonthRange } from '../../../utils/localDate.js';
import { formatCurrencyWhole } from '../../../utils/formatCurrency.js';

const SETTLEMENT_ROLES = ['Admin', 'Accountant', 'System Admin'];

const SettlementReviewChip = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const roleName = user?.role;
  const allowed = SETTLEMENT_ROLES.includes(roleName);

  useEffect(() => {
    if (!allowed) return undefined;
    let cancelled = false;
    const range = getCurrentMonthRange();
    (async () => {
      try {
        const summaryRes = await companySettlementService.getSummary({
          from_date: range.fromDate,
          to_date: range.toDate,
        });
        if (cancelled) return;
        const summary = summaryRes?.data || {};
        const due = Number(summary?.paid?.amount_outstanding || 0)
          + Number(summary?.to_pay?.amount_outstanding || 0);
        setStats({ due });
      } catch {
        if (!cancelled) setStats({ due: 0 });
      }
    })();
    return () => { cancelled = true; };
  }, [allowed]);

  if (!allowed || !stats) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/company-settlement-approvals')}
      className="shrink-0 rounded-lg border border-rose-200 bg-rose-50 px-2.5 py-1.5 text-left hover:bg-rose-100 transition-colors"
    >
      <p className="text-[10px] sm:text-xs font-semibold text-rose-950 leading-tight">Settlement review</p>
      <p className="text-[10px] sm:text-xs text-rose-800/90 mt-0.5 leading-tight whitespace-nowrap">
        {formatCurrencyWhole(stats.due || 0)} due
      </p>
    </button>
  );
};

export default SettlementReviewChip;
